import {DomainName} from '../types';

import {
    useCreateDomainNameMutation,
    useDeleteDomainNameMutation,
    useDomainNameQuery,
    useUpdateDomainNameMutation,
} from './useDomainNamesQuery';

// FNP-942: the single record comes from React Query. The return shape is
// unchanged so EditPage and the forms that consume this hook did not change.
export const useDomainName = (domainNameId?: string) => {

    const {
        data: record,
        isLoading,
        refetch
    } = useDomainNameQuery(domainNameId);

    const createMutation = useCreateDomainNameMutation();
    const updateMutation = useUpdateDomainNameMutation();
    const deleteMutation = useDeleteDomainNameMutation();

    // FETCH
    const fetchRecord = () => {
        if (typeof domainNameId === 'undefined') {
            throw new Error('domainNameId is required parameter');
        }
        refetch();
    };

    // CREATE, UPDATE DELETE
    const createRecord = (values: DomainName) => {
        createMutation.mutate(values);
    };

    const updateRecord = (values: DomainName) => {
        if (typeof domainNameId === 'undefined') {
            throw new Error('domainNameId is required parameter');
        }

        updateMutation.mutate({
            id: domainNameId,
            record: values,
        });
    };

    const deleteRecord = () => {
        if (typeof domainNameId === 'undefined') {
            throw new Error('domainNameId is required parameter');
        }
        deleteMutation.mutate(domainNameId);
    };


    return {
        record,
        loading: isLoading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
